import { FunctionalComponent, h } from '@stencil/core';
import { FundDataPoints } from '../../../_interfaces/fund-card/fund-data-points';

interface InceptionNetProps {
	flag: boolean;
	dataPointValues: FundDataPoints;
	Tooltip: string;
}

export const InceptionNet: FunctionalComponent<InceptionNetProps> = ({
	dataPointValues,
	flag,
	Tooltip,
}) => {
	if (flag)
		return (
			<div class="ds-data-points">
				{dataPointValues.general ? (
					<div class="ds-right-col">
						<div class="ds-body-s">{dataPointValues.label}</div>
						<div class="ds-fund-data">{dataPointValues.data}</div>
					</div>
				) : null}

				{dataPointValues.secondaryGeneral ? (
					<div class="ds-left-col">
						<div class="ds-body-s">
							{dataPointValues.secondaryLabel}&nbsp;
							{dataPointValues.secondaryTooltip ? (
								<Tooltip
									content={dataPointValues.secondaryTooltip.first}
								></Tooltip>
							) : null}
						</div>
						<div class="ds-fund-data">{dataPointValues.secondaryData}</div>
					</div>
				) : null}
			</div>
		);
};
